<template>
  <modal :show.sync="showModal" size="lg">
    <h6 slot="header" class="modal-title">Editar Sponsor: {{fetchSponsor.name}}</h6>
    <form class="needs-validation" id="formEditSponsor"
        @keyup.enter="eventoEnter($event)"
        @submit.prevent="sendForm($event)">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      name="nombre"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="sponsor.name">
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <base-input
            label="País"
            name="pais"
            placeholder=""
            :error="getError('pais')"
            v-validate="'required'"
            v-model="sponsor.pais"
          >
            <el-select clearable v-model="sponsor.pais" filterable
                        placeholder="Seleccione país">
                <el-option v-for="option in selectPaises"
                            :key="option.label"
                            :label="option.label"
                            :value="option.value">
                </el-option>
            </el-select>
          </base-input>
        </div>
      </div>
      <h3>Permisos posibles</h3>
      <div class="container">
        <div class="form-row" v-for="(atributo,index) in Object.keys(permisos)" :key="index">
          <h4>{{atributo | capitalize}}</h4>
          <div class="col-md-12 d-flex flex-wrap">
            <base-checkbox v-for="(item,indice) in Object.keys(permisos[atributo])" :key="indice" class="mb-3 mr-2" v-model="permisos[atributo][item]">
                {{item}}
            </base-checkbox>
          </div>
        </div>
      </div>
      <!--
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Permisos disponibles para este sponsor:">
                    <tags-input  v-model="sponsor.permisos" placeholder="Agregar nuevo permiso..." class=""></tags-input>
                </base-input>
          </div>
      </div>
      -->
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formEditSponsor">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
import TagsInput from '@/components/Inputs/TagsInput';
import { Select, Option } from 'element-ui';

  export default {
    components: {
        TagsInput,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
      return {
        validated: false,
        sponsor: {
            id: '',
          name: '',
          permisos: [],
          pais: undefined
        },
        fetchSponsor: {
          name: '',

        },
        showModal: false,
        change_password: "0",
        reglasConfirmacion: '',
        reglasPassword: '',
        sponsor_id: null,
        selectSponsors: [],
        permisos_editable: false,
        permisos: {
          usuarios: {
            'show management': false,
            'create': false,
            'update': false,
            'update sponsor': false,
            'update sucursal': false,
            'update equipo': false,
          },
          equipos: {
            'show management': false,
            'create': false,
            'update': false,
            'update sucursal': false,
            'update sponsor': false,
            'update permisos': false,
          },
          sucursales: {
            'show management': false,
            'create': false,
            'update': false,
            'update sponsor': false,
          },
          sponsors: {
            'show management': false,
            'create': false,
            'update': false,
            'update permisos': false,
          },
          planes: {
            'show management': false,
            'create': false,
            'update': false,
            'update company': false,
            'update sponsor': false,
          },
          subcategorias: {
            'show management': false,
            'create': false,
            'update': false,
          },
          categorias: {
            'show management': false,
            'create': false,
            'update': false,
          },
          materias: {
            'show management': false,
            'create': false,
            'update': false,
            'update sponsor': false,
          },
        },
        checkbox_test: true,
        selectPaises: [
          { label: 'Chile', value: 'Chile' },
          { label: 'Perú', value: 'Perú' },
          { label: 'Colombia', value: 'Colombia' },  
          { label: 'Ecuador', value: 'Ecuador' },  
          { label: 'Argentina', value: 'Argentina' },
        ],
      }
    },
    methods: {
      eventoEnter(evt){
          console.log('metodo EventoEnter: ');
          //console.log(evt);
          evt.stopPropagation();
      },
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      sendForm(evt){
          console.log('metodo sendForm: ');
          console.log(evt);
        var vm = this;
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          
          if( response ){
            var arregloPermisos = [];
            Object.keys(vm.permisos).forEach( (entidad,index) => {
              Object.keys(vm.permisos[entidad]).forEach( (permiso, indice) =>{
                if( vm.permisos[entidad][permiso] ) arregloPermisos.push(permiso+' '+entidad);
                
              });
            });
            vm.axios({
                method: 'PUT',
                url: 'api/edit_sponsor',
                data: {   
                          sponsor: vm.sponsor.id,
                          name: vm.sponsor.name,
                          //permisos: vm.sponsor.permisos,
                          permissions: arregloPermisos,
                          pais: vm.sponsor.pais
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Sucursal editada exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo modificar el sponsor',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
          
        }).catch( reason => {
          console.log(reason);
        });
      },
      fetchDataTeam(sponsor_id)
      {
        var vm = this;
        
        return this.axios({
            method: 'GET',
            url: 'api/edit_sponsor?sponsor='+sponsor_id
        }).then(response => {
            this.fetchSponsor.name = this.sponsor.name = response.data.name;
            this.fetchSponsor.id = this.sponsor.id = response.data.id;
            this.sponsor.pais = response.data.pais;
            //this.sponsor.permisos = response.data.permisos;
            this.permisos_editable = response.data.editable;
            this.showModal = true;
            this.sponsor_id = sponsor_id;

            vm.permisos = {};
            Object.keys(response.data.todosLosPermisos).forEach( (entidad, index) => {
              vm.permisos[entidad] = {};
              response.data.todosLosPermisos[entidad].forEach( (permiso, indice) => {
                vm.permisos[entidad][permiso] = false;
              });
            });
            Object.keys( response.data.objPermisos ).forEach( (entidad,index) => {
              response.data.objPermisos[entidad].forEach( (permiso, indice) => {
                vm.permisos[entidad][permiso] = true;
              });
            });
        }).catch( error => {
            console.log(error);
        })
        ;
      },
    },
    mounted()
    {
        
    },
    created()
    {
      this.$parent.$on('loadModalEditSponsor', (sponsor_id) => { this.fetchDataTeam(sponsor_id) } );
    },
  }
</script>
<style>
</style>
